<template>
  <v-layout
      row
      :style="maxWidth"
  >
    <v-flex
        class="ml-3 pl-sm-1"
        :style="maxWidth"
    >
      <breadcrumbs
          :items="breadcrumbsItems"
      ></breadcrumbs>
      <v-card class="ma-1" outlined :style="maxHeight">
        <v-row>
          <v-card-title class="pl-6">
            Admins
          </v-card-title>
          <hr class="ma-1">
            <v-row>
                <v-col cols="6">
                    <v-text-field
                        v-model="searchAdmins"
                        append-icon="mdi-magnify"
                        label="Search"
                        hide-details
                        class="ma-1"
                        outlined
                        autocomplete="off"
                        dense
                    ></v-text-field>
                </v-col>
                <v-col style="text-align: right;" class="pr-12">
                    <v-btn class="ma-1 font-weight-bold"
                           color="success"
                           @click="createAdmin()"> + Add Admin
                    </v-btn>
                </v-col>
            </v-row>
<!--          <v-col style="text-align: right;" class="pr-12">-->
<!--            <v-btn class="ma-1 font-weight-bold"-->
<!--                   color="success"-->
<!--                   @click="createAdmin()"> + Add Admin-->
<!--            </v-btn>-->
<!--          </v-col>-->
        </v-row>
        <v-data-table
            :headers="headers"
            :items="admins"
            :seach="searchAdmin"
            dense
            class="display-3 font-weight-medium"
            :fixed-header="true"
            height="450"
        >
          <template
              v-slot:item.actions="{ item }"
          >
            <v-icon
                class="mr-8"
                @click="editAdmin(item)"
            >
              mdi-pencil
            </v-icon>
            <v-icon
                color="red"
                @click="deleteAdmin(item)"
            >
              mdi-delete
            </v-icon>
          </template>
        </v-data-table>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import axios from "axios";

export default {
  name: 'outlet-admins',
  props: ['user'],
  data: () => ({
    admins: [],
    searchAdmin: null,
    breadcrumbsItems: [],
  }),
  computed: {
    headers() {
      return [
        {
          text: 'Name',
          align: 'start',
          value: 'name',
          label: 'Name',
          field: 'name',
        },
        {
          text: 'Email',
          value: 'email',
          label: 'Email',
          field: 'email',
        },
        {
          text: 'Contact',
          value: 'phone_no',
          label: 'Contact',
          field: 'phone_no',
        },
        {
          text: 'Actions',
          value: 'actions',
          sortable: false
        }
      ]
    },
    maxWidth() {
      return {
        maxWidth: window.outerWidth + 'px'
      }
    },
    maxHeight() {
      return {
        maxHeight: window.innerHeight + 'px'
      }
    }
  },
  methods: {
    createAdmin() {
      window.location.href = '/admin/create'
    },
    editAdmin(a) {
      window.location.href = '/admin/' + a.id + '/edit'
    },
    deleteAdmin(a) {
      const i = this.admins.indexOf(a);
      if (confirm('Are you sure you want to delete this admin?')) {
        axios.delete('/admin/' + a.id).then(response => {
          this.admins.splice(i, 1);
        });
      }
    },
  },
  beforeMount() {
    axios.post('/api/outletAdmins/', {
      outlet_id: this.user.outlet_id
    }).then(response => {
      this.admins = response.data
    })
    this.breadcrumbsItems = [
      {
        disabled: false,
        href: '/',
        link: true,
        text: 'Home',
      },
      {
        disabled: true,
        href: '#',
        link: true,
        text: 'Admins',
      },
    ];
  }
}

</script>

<style>
.v-data-table-header th {
  white-space: nowrap;
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/Outlets/OutletAdmin.vue